import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import { formatDate } from 'utils/helpers'

const ACTION_LABELS: Record<string, string> = {
  CREATE: 'Create',
  UPDATE: 'Update',
  CANCEL: 'Cancel',
  WEBHOOK: 'Webhook',
}

type GetColumnsParams = {
  page: number
  onView: (id: string) => void
}

export const getColumns = ({ page, onView }: GetColumnsParams) =>
  [
    {
      headerName: '#',
      field: '_id',
      maxWidth: 80,
      valueFormatter: (params: ValueFormatterParams) => {
        return (params.node?.rowIndex as number) + 1 + page
      },
    },
    {
      headerName: 'Order No',
      field: 'orderNo',
      minWidth: 150,
    },
    {
      headerName: 'Order Status',
      field: 'orderStatus',
      minWidth: 140,
      valueFormatter: (params: ValueFormatterParams) => params.value || '-',
    },
    {
      headerName: 'Aggregator Code',
      field: 'aggregatorCode',
      minWidth: 150,
      valueFormatter: (params: ValueFormatterParams) => params.value || '-',
    },
    {
      headerName: 'Store Code',
      field: 'storeCode',
      minWidth: 130,
      valueFormatter: (params: ValueFormatterParams) => params.value || '-',
    },
    {
      headerName: 'Action',
      field: 'action',
      minWidth: 130,
      cellRenderer: (params: ICellRendererParams) => {
        const v: string = params.value
        if (!v) return <span>-</span>
        return (
          <span className="rounded-lg bg-blue-100 px-2 py-1 text-sm text-blue-700">
            {ACTION_LABELS[v] || v}
          </span>
        )
      },
    },
    {
      headerName: 'Status',
      field: 'status',
      minWidth: 120,
      cellRenderer: (params: ICellRendererParams) => {
        const v: string = params.value
        if (!v) return <span>-</span>
        return (
          <span
            className={`rounded-lg px-2 py-1 text-sm ${
              v === 'SUCCESS'
                ? 'bg-green-400 text-black'
                : 'bg-red-500 text-white'
            }`}
          >
            {v === 'SUCCESS' ? 'Success' : 'Failed'}
          </span>
        )
      },
    },
    {
      headerName: 'Response Code',
      field: 'responseCode',
      maxWidth: 150,
      valueFormatter: (params: ValueFormatterParams) => params.value ?? '-',
    },
    {
      headerName: 'Error Message',
      field: 'errorMessage',
      minWidth: 200,
      valueFormatter: (params: ValueFormatterParams) => params.value || '-',
    },
    {
      headerName: 'Synced At',
      field: 'syncedAt',
      minWidth: 180,
      valueFormatter: (params: ValueFormatterParams) =>
        params.value ? formatDate(params.value, { includeTime: true }) : '-',
    },
    {
      headerName: 'Actions',
      field: '_id',
      maxWidth: 100,
      sortable: false,
      cellRenderer: (params: ICellRendererParams) => (
        <button
          type="button"
          className="text-sm font-semibold text-sidebar-primary hover:underline"
          onClick={() => onView(params.value)}
        >
          View
        </button>
      ),
    },
  ] as ColDef[]
